import {
  PredicateType,
  type ResponseBodyEvaluation,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const prometheusResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.data.result.length()',
        type: PredicateType.Number,
        comparator: 'EQU',
        rValue: '0.0'
      }
    ]
  }

export const prometheusStatusCheckIntegration: TeamExternalIntegration = {
  authUrl: '',
  headers: [],
  isPrivateNetworkIntegration: false,
  name: 'Prometheus',
  sortIndex: 6,
  type: IntegrationType.Prometheus,
  url: ''
}
